import { getWorkflowStepByKey } from 'app/workflows/selectors';
import { connect } from 'react-redux';
import type { AppState } from '../../../app-state.js';
import StatusIndicatorCell, { type StatusIndicatorCellOwnProps } from './status-indicator-cell.js';

export type StatusIndicatorCellStateProps = {
  color: string;
  title: string;
};

export const mapStateToProps = (
  state: AppState,
  ownProps: StatusIndicatorCellOwnProps
): StatusIndicatorCellStateProps => {
  const workflowStep = getWorkflowStepByKey(state, { stepKey: ownProps.value });
  const color = workflowStep ? workflowStep.color : '';
  const title = workflowStep ? workflowStep.title : ownProps.value;
  return { color, title };
};

export default connect(mapStateToProps)(StatusIndicatorCell);
